import React from "react";
import { graphql } from "gatsby";
import { MDXProvider } from "@mdx-js/react";
import { MDXRenderer } from "gatsby-plugin-mdx";
import { Link } from "gatsby";
import Layout from "../components/Layout";
import SectionTitle from "../components/SectionTitle";
import { contentWidth, pageWidth } from "../constants";
import { Helmet } from "react-helmet";

const shortcodes = { Link }; // Provide common components here
export default function PageTemplate({ data: { mdx } }) {
  const bookSlug = mdx.fields.slug.split("/")[1];
  const sectionNumber = parseInt(mdx.fields.slug.split("/")[2]);
  return (
    <Layout showNav={false}>
      <Helmet>
        <title>
          {mdx.frontmatter.isBook
            ? mdx.frontmatter.title
            : mdx.frontmatter.title + " | " + mdx.frontmatter.bookTitle}
        </title>
      </Helmet>
      {/* <SectionTitle>{mdx.frontmatter.title}</SectionTitle> */}
      {!mdx.frontmatter.isBook && (
        <LocationHint
          bookTitle={mdx.frontmatter.bookTitle}
          sectionTitle={mdx.frontmatter.title}
          numSections={mdx.frontmatter.numSections}
          bookSlug={bookSlug}
          sectionNumber={sectionNumber}
        />
      )}
      <div class="flex flex-col">
        <div class="my-32 font-sans">
          {mdx.frontmatter.isBook ? (
            <>
              <div class="text-xl mb-2 font-semibold">
                {mdx.frontmatter.title}
              </div>
              <div class="text-lg font-serif">{mdx.frontmatter.author}</div>
              <div class="h-px mb-4" style={{ background: "#bbb" }} />
            </>
          ) : (
            <div
              class="text-xl mb-4 text-center"
              style={{
                maxWidth: contentWidth,
                width: "70%",
              }}
            >
              {mdx.frontmatter.title}
            </div>
          )}
          <MDXProvider components={shortcodes}>
            <MDXRenderer>{mdx.body}</MDXRenderer>
          </MDXProvider>
        </div>
      </div>
    </Layout>
  );
}
export const pageQuery = graphql`
  query BlogPostQuery($id: String) {
    mdx(id: { eq: $id }) {
      id
      body
      fields {
        slug
      }
      frontmatter {
        isBook
        title
        bookTitle
        numSections
        tags
        author
      }
    }
  }
`;

const LocationHint = ({
  bookTitle,
  sectionTitle,
  bookSlug,
  sectionNumber,
  numSections,
}) => {
  return (
    <>
      <div
        class="bg-white z-10 py-1"
        style={{
          position: "sticky",
          top: "0",
          boxShadow: "0 0px 16px 12px rgba(255, 255, 255, 1)",
          width: "100%",
        }}
      >
        <div class="flex flex-row text-sm">
          <div>
            <Link to={`/${bookSlug}`}>
              <SectionTitle>{bookTitle}</SectionTitle>
            </Link>
          </div>
          <div class="font-serif mx-2 text-gray-500">{">"}</div>
          <div>
            <Link to={`/${bookSlug}/${sectionNumber}`}>
              <SectionTitle>{sectionTitle}</SectionTitle>
            </Link>
          </div>
        </div>
      </div>
      {/* hover nav */}
      <div class="flex flex-row font-serif">
        <div
          style={{
            maxWidth: contentWidth,
            width: "80%",
          }}
        />
        <p class="text-sm">
          <div
            class="fixed z-10"
            style={{
              bottom: "10%",
              width: "20%",
              maxWidth: "160px",
            }}
          >
            <div
              class="flex bg-white md:ml-6 md:flex-row flex-col justify-between font-serif underline items-center text-gray-500"
              style={{
                height: "60px",
                boxShadow: "0 0px 8px 6px rgba(255, 255, 255, 1)",
              }}
            >
              <Link
                style={{
                  visibility: sectionNumber > 0 ? "visible" : "hidden",
                }}
                to={`/${bookSlug}/${sectionNumber - 1}`}
              >
                ← prev
              </Link>
              <Link
                style={{
                  visibility:
                    sectionNumber < numSections - 1 ? "visible" : "hidden",
                }}
                to={`/${bookSlug}/${sectionNumber + 1}`}
              >
                next →
              </Link>
            </div>
          </div>
        </p>
      </div>
    </>
  );
};
